import React from 'react';
import { Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { Row } from './styles';
import { TouchableWithoutFeedback, View } from 'react-native';
import styled from 'styled-components/native';
import { ColumnWithMargins, RowSpaceBetween } from 'styles/ContainerStyles';
import { isWeb } from 'utils/deviceUtils';
import { useAttachmentRow } from './useAttachmentRow';

const Shrink = styled.View`
  flex-shrink: 1;
`;

type AttachmentProps = {
  noBorder?: boolean;
  pressable?: boolean;
};

const Attachment: React.FC<AttachmentProps> = ({
  noBorder = false,
  pressable = true,
}) => {
  const { title, displayName, fullName, handlePress } = useAttachmentRow({
    pressable,
  });

  // Web has no working attachment flow: no picker modal and no preview route.
  if (isWeb) return null;

  const content = (
    <RowSpaceBetween
      padding={15}
      withTopBorder={!noBorder}
      borderColor={theme.colors.white}>
      <ColumnWithMargins maxWidth="60%">
        <Meta
          color={theme.colors.gray300}
          numberOfLines={1}
          ellipsizeMode="tail">
          {title}
        </Meta>
      </ColumnWithMargins>
      <Shrink>
        <Row justify="flex-end">
          <Meta numberOfLines={1} ellipsizeMode="tail">
            {displayName}
          </Meta>
          {pressable && <Icon name="Chevron_Right" />}
        </Row>
      </Shrink>
    </RowSpaceBetween>
  );

  return (
    <TouchableWithoutFeedback
      accessible
      accessibilityLabel={`${title}: ${fullName}`}
      testID="selected-attachment"
      onPress={handlePress}>
      <View>{content}</View>
    </TouchableWithoutFeedback>
  );
};

export default Attachment;
